module.exports = __webpack_public_path__ + "img/mop_905017_r3@2x.592c8cd7.png";